module.exports = __webpack_public_path__ + "img/text.63f908ec.svg";